import { render, staticRenderFns } from "./BookmarkedItems.vue?vue&type=template&id=4ea993fb"
import script from "./BookmarkedItems.vue?vue&type=script&lang=js"
export * from "./BookmarkedItems.vue?vue&type=script&lang=js"
import style0 from "./BookmarkedItems.vue?vue&type=style&index=0&id=4ea993fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports